export default __webpack_public_path__ + "static/media/person.62144193.png";